import clsx from "clsx";
import React, {ReactNode, useEffect, useRef, useState} from "react";
import FfairTooltip from "view/components/Layout/Tooltip";
import {sanitizeHtml} from "view/components/SafeHtml";
import useStyles from "../styles";

type ElipsisWrapperProps = {
  value: ReactNode;
  className?: string;
  textColor?: string;
};

const ElipsisWrapper: React.FC<ElipsisWrapperProps> = ({
  value,
  className,
  textColor,
}) => {
  const classes = useStyles();

  const valueRef = useRef<HTMLDivElement | null>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    if (!valueRef.current) {
      return;
    }

    const element = valueRef.current;
    setIsEllipsis(element.scrollWidth > element.offsetWidth);
  }, [value]);

  if (typeof value === "string") {
    return (
      <FfairTooltip title={isEllipsis ? value : ""} placement="top-end">
        <div
          ref={valueRef}
          style={{color: textColor}}
          dangerouslySetInnerHTML={{__html: sanitizeHtml(value)}}
          className={clsx(classes.overflowHidden, className)}
        />
      </FfairTooltip>
    );
  }

  return <>{value}</>;
};

export default ElipsisWrapper;
